// extracted by mini-css-extract-plugin
export default {"container":"ShortcutTooltip-module__container--SYenu","shortcut":"ShortcutTooltip-module__shortcut--D8+dp","animatedBackground":"ShortcutTooltip-module__animatedBackground--D2CHa"};